enum LoginErrorString {
    INVALID_LOGIN_CODE = 'The code you provided is invalid. Please check your code and try again.',
    LOGIN_CODE_EXPIRED = 'The code you provided has expired',
}

const isLoginErrorString = (str: string): str is LoginErrorString => {
    switch (str) {
        case LoginErrorString.INVALID_LOGIN_CODE:
        case LoginErrorString.LOGIN_CODE_EXPIRED:
            return true;

        default:
            return false;
    }
};

export { LoginErrorString, isLoginErrorString };
